exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table[data-v-5074f2df]{overflow:auto;position:relative}.el-table :deep(.el-table__fixed-header-wrapper) thead th>.cell[data-v-5074f2df]{white-space:nowrap !important}.el-table :deep(.el-table__header-wrapper) thead th>.cell[data-v-5074f2df]{white-space:nowrap !important}\n", ""]);

// exports
